<template>
  <div class="bg-white">
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="common-margin-top common-letter-spacing container">
      <div>
        <p class="common-padding-top font-20 text-center">这个场景我们仅提供支付服务，合作方自有系与<!--广东快付-->银典科技合作前后的变化要点。</p>
        <table class="table table-bordered table-striped common-margin-top common-padding-top">
          <thead>
          <tr><th>合作前</th>
            <th>合作后</th></tr>
          </thead>
          <tbody class="font-14">
            <tr><td>对接了微信、支付宝支付，但是使用一段时间后被支付宝风控（模式涉嫌传销 ） </td>
              <td>对接<!--广东快付-->银典科技APP，使用一年多了，没出现风控问题。</td></tr>
            <tr><td>层级分润，店主分佣都是人工转账。</td>
              <td>层级分润，店主分佣使用了<!--广东快付-->银典科技分账系统，通过分账系统调用出款，从商户钱包发放分润和分佣。</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '社交电商',
        url: '#',
        describe: '某社交电商APP，多层级分润，人人开店，购买商品即送店主身份。平台提供货源、发货、物流服务，店主只需要卖货就可以获取佣金，佣金只能每月20号提现。'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Sjds.vue